import { BASE_URL } from "app/config/env";

export const publicRoutes = {
  "public.privacy-policy": `${BASE_URL}/privacy-policy`,
  "public.rules": `${BASE_URL}/rules`,
  "public.eu": `${BASE_URL}/eu`,
};
